import { create } from 'zustand';

interface LoadingState {
  isInitalFetchDone: boolean;
  isInitialRendered: boolean;
  setIsInitialFetchDone: (value?: boolean) => void;
  setIsInitialRendered: (value?: boolean) => void;
}

const useLoadingStore = create<LoadingState>()((set, get) => ({
  isInitalFetchDone: false,
  isInitialRendered: false,

  setIsInitialFetchDone: (value?: boolean) => {
    set({
      isInitalFetchDone: value ?? true,
    });
  },

  setIsInitialRendered: (value?: boolean) => {
    set({
      isInitialRendered: value ?? true,
    });
  },
}));

export default useLoadingStore;
